export default "__VITE_ASSET__HMW690xk__"